<template>
    <div class="layout">
        <keep-alive include="XiazengBarcodeBindList">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: "Layout",
    data() {
        return {};
    },
    created() {},
    methods: {}
};
</script>

<style scoped>
</style>


